import { FONT, WEIGHT } from '../../styles/foundation/typography';
import { SUBTLE, PRIMARY_BLUE, SUCCESS, ORANGE, ERROR, TEAL, withOpacity } from '../../styles/foundation/colors';

// A muted slate-indigo for "waiting" states — softer than the app's saturated PURPLE token,
// reads as calm/neutral rather than an alert color.
const SLATE = '#6B7BAB';

// Freshdesk ticket-status id -> tone, shared across the list, detail, and export views so a
// given status always reads the same color everywhere. Ids come from GET_FRESHDESK_STATUS_LIST
// (2 Open, 3 Pending, 4 Closed, 5 Resolved, 6 Waiting on Customer, 9 Waiting on Third Party,
// 10 Escalated) — only the color mapping is ours; always display label_for_customers, not label.
// No yellow anywhere in this map — Pending uses orange instead of the yellow WARNING token.
export const STATUS_TONE = {
    2: PRIMARY_BLUE, 3: ORANGE, 4: SUBTLE, 5: SUCCESS, 6: SLATE, 9: TEAL, 10: ERROR,
};

export const statusTone = (id) => STATUS_TONE[id] || PRIMARY_BLUE;

export const statusChipSx = (id) => {
    const c = statusTone(id);
    return {
        fontFamily: FONT, fontWeight: WEIGHT.bold, fontSize: '0.7rem',
        bgcolor: withOpacity(c, 0.12), color: c, border: `1px solid ${withOpacity(c, 0.3)}`,
    };
};
